import { rgba } from 'polished';
import { Dispatch, useCallback } from 'react';
import MyProfileImage from 'src/components/filmwebid/MyProfileImage';
import UserName from 'src/components/filmwebid/UserName';
import FilmwebLink from 'src/components/filmweblink/FilmwebLink';
import LogoutButton from 'src/components/menu/LogoutButton';
import { IMenuAction } from 'src/components/menu/SearchAndDropdownMenu';
import slideUp from 'src/components/styles/slideUp';
import CogSvg from 'src/components/svg/CogSvg';
import HeartSvg from 'src/components/svg/HeartSvg';
import SpeechBubbleSvg from 'src/components/svg/SpeechBubbleSvg';
import StarSvg from 'src/components/svg/StarSvg';
import WatchlistSvg from 'src/components/svg/WatchlistSvg';
import theme from 'src/components/themes/DefaultTheme';
import { envConfig } from 'src/lib/client/envConfig';
import { useUserContext } from 'src/lib/contexts/UserContext';
import styled from "src/lib/styles/css";


//#region [Props]
type FilmwebIdDropDownMenuProps = {
    isVisible: boolean;
    dispatch: Dispatch<IMenuAction>;
};
//#endregion

//#region [Component]
export default function FilmwebIdDropDownMenu({ isVisible, dispatch }: FilmwebIdDropDownMenuProps) {
    const authContext = useUserContext();

    const onPostClick = useCallback(() => {
        dispatch({ type: "TOGGLE_FILMID_MENU" });
    }, [dispatch]);

    if (!authContext.isAuthenticated) {
        return null;
    }

    return <SFilmwebIdDropDownMenuContainer className={!isVisible ? "invisible" : ""}>
        <SFilmwebIdDropDownMenu className={isVisible ? "isvisible" : ""}>
            <SMenuContent>
                <SMyProileImage />
                <SUserName />
                <SMenuLink to={`${envConfig.NEXT_PUBLIC_MINSIDE_BASE}/huskeliste`} onClick={onPostClick}><WatchlistSvg className='Icon' /><span>Min huskeliste</span></SMenuLink>
                <SMenuLink to={`${envConfig.NEXT_PUBLIC_MINSIDE_BASE}/favoritter`} onClick={onPostClick}><HeartSvg className="Icon" /><span>Mine favoritter</span></SMenuLink>
                <SMenuLink to={`${envConfig.NEXT_PUBLIC_MINSIDE_BASE}/minevurderte`} onClick={onPostClick}><StarSvg className="Icon" /> <span>Mine vurderinger</span></SMenuLink>
                <SMenuLink to={`${envConfig.NEXT_PUBLIC_MINSIDE_BASE}/anmeldelser`} onClick={onPostClick}><SpeechBubbleSvg className="Icon" /> <span>Mine anmeldelser</span></SMenuLink>
                <SMenuLink to={`${envConfig.NEXT_PUBLIC_MINSIDE_BASE}/innstillinger`} onClick={onPostClick}><CogSvg className="Icon" /> <span>Min profil/innstillinger</span></SMenuLink>
                <LogoutButton />
            </SMenuContent>
        </SFilmwebIdDropDownMenu>
    </SFilmwebIdDropDownMenuContainer>;
}
//#endregion

//#region [Styles]

const SFilmwebIdDropDownMenuContainer = styled.div`
	position: absolute;
	z-index: 102;
	right: 0;
	max-width: 400px;
	min-width: min(400px, 100vw);
	overflow: hidden;

    top: 55px;

    &.invisible {
        pointer-events: none;
    }

`;

const SFilmwebIdDropDownMenu = styled.div`
    border-bottom-left-radius: var(--panel-borderradius);
    border-bottom-right-radius: var(--panel-borderradius);
	background-color: ${rgba(theme.mainColor, theme.generalAlpha)};

    padding: var(--page-padding);

    overflow: hidden;
    box-sizing: border-box;

    /*animation:*/${slideUp} 0.1s linear 0s;
	transform: translateY(-100%);
	transition: transform 0.1s;


	@media (min-width: 550px) {
		padding: 50px;
	}
    &.isvisible {
        transform: translateY(0) !important;
    }
`;

const SMenuContent = styled.nav`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 25px;
`;

const SMyProileImage = styled(MyProfileImage)`
	--portrait-size: 100px;
	align-self: center;
	border: 3px solid ${theme.palette.turkis2};
`;

const SUserName = styled(UserName)`
	color: var(--textcolor);
	text-align: center;
`;

const SMenuLink = styled(FilmwebLink)`
	margin-left: 0;
	text-decoration: none;
	color: var(--inlinelinkcolor);
	padding-left: 20%;
	display: flex;
	gap: 10px;
	align-items: center;
	min-height: none;

	&:hover {
		text-decoration: underline;
	}

	.Icon {
		flex: 0 0 30px;
	}

	span {
		flex: 1 1 auto;
	}
`;
//#endregion